var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"box"},[(!_vm.hideLabel)?_c('span',{staticClass:"country-label",style:({order: _vm.beforeImg ? '2' : '0'})},[_vm._v(" "+_vm._s(this.$utils.pipeCountryCode(_vm.code))+" ")]):_vm._e(),_c('img',{staticClass:"country-img",attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }